import axios, { AxiosResponse } from 'axios';
import { TData } from '/react4xp/parts/find-taxpayer-service/find-taxpayer-service.type';

const urlSync = `/services/isnaportalsync/open-api/taxpayer-data`;

export const urlPrint = urlSync;

export const getTaxPayerInfo = (
    request: any,
    secretKey?: any,
    token?: any
): Promise<AxiosResponse> => {
    let query = '?';
    if (secretKey) query += `token=${secretKey}`;

    return axios.get(urlSync, {
        params: {
            taxpayerCode: request.iinBin,
            firstName: request.firstName,
            lastName: request.lastName,
            name: request.organizationName,
            taxpayerType: request.type,
        }
    }).then((response) => {
        if (response.data.taxpayerPortalSearchResponses && response.data.taxpayerPortalSearchResponses.length > 0) {
            const rawDataList = response.data.taxpayerPortalSearchResponses || [];

            const tDataList: TData[] = rawDataList.map((data: any) => ({
                beginDate: data.beginDate,
                endDate: data.endDate,
                iinBin: data.code,
                lzchpType: data.taxpayerType,
                name: data.name,
                reason: data.additionalInfo?.ru || '',
                rnn: data.code,
                suspensionPeriod:
                    data.additionalInfo?.beginDate && data.additionalInfo?.endDate
                        ? `${data.additionalInfo.beginDate} - ${data.additionalInfo.endDate}`
                        : '',
                type: data.taxpayerType,
                ulTaxInfo: [],
            }));

            return {
                ...response,
                data: {taxpayers: tDataList},
                total: 1
            };
        }

        return response;
    });
};
